'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.d3Event = exports.eventDrops = undefined;

var _configurable = require('configurable.js');

var _configurable2 = _interopRequireDefault(_configurable);

var _d = require('d3');

require('./style.css');

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _drawer = require('./drawer');

var _drawer2 = _interopRequireDefault(_drawer);

var _zoom = require('./zoom');

var _zoom2 = _interopRequireDefault(_zoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import * as d3 from 'd3/build/d3';
var eventDrops = function eventDrops() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var finalConfiguration = Object.assign({}, _config2.default, config);

    var yScale = function yScale(data) {
        var handler = (0, _d.scaleOrdinal)().domain(data.map(function (d) {
            return d.name;
        })).range(data.map(function (d, i) {
            return i * finalConfiguration.lineHeight;
        }));
        return handler;
    };

    var xScale = function xScale(width, timeBounds) {
        return (0, _d.scaleTime)().domain(timeBounds).range([0, width]);
    };

    function eventDropGraph(selection) {
        return selection.each(function selector(data) {
            finalConfiguration.leftWidth = finalConfiguration.displayLabels ? finalConfiguration.labelsWidth + finalConfiguration.labelsRightMargin : 0;
            (0, _d.select)(this).select('.event-drops-chart').remove();

            var dimensions = {
                width: this.clientWidth,
                height: data.length * finalConfiguration.lineHeight
            };

            var svg = (0, _d.select)(this).append('svg').classed('event-drops-chart', true).attr('width', dimensions.width + (finalConfiguration.margin.left + finalConfiguration.margin.right)).attr('height', dimensions.height + finalConfiguration.margin.top + finalConfiguration.margin.bottom);

            var scales = getScales(dimensions, finalConfiguration, data);

            var draw = (0, _drawer2.default)(svg, dimensions, scales, finalConfiguration);
            draw(data);

            if (finalConfiguration.zoomable) {
                (0, _zoom2.default)(svg, dimensions, scales, finalConfiguration, data, finalConfiguration.zoomStreamCallback);
            }
        });
    }

    function getScales(dimensions, configuration, data) {
        return {
            x: xScale(dimensions.width - finalConfiguration.leftWidth, [configuration.start, configuration.end]),
            y: yScale(data)
        };
    }

    (0, _configurable2.default)(eventDropGraph, finalConfiguration);

    return eventDropGraph;
};

// chart = chart || {};
// chart.eventDrops = eventDrops;

exports.eventDrops = eventDrops;
exports.d3Event = _d.event;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/index.js
// module id = ../../../../ansyn-event-drops/dist-es5/index.js
// module chunks = vendor